import { Map } from 'immutable';

import { EXT_TO_MIME } from '../../constants/photos';
import { EMPTY } from '../../constants';

export function shapeFoldersForApp(result, folder) {
  const { folder_name: name, image_count: count, uuid } = folder;

  function updateById(byId = EMPTY.MAP) {
    return byId.set(uuid, Map({ count: parseInt(count), name, uuid }));
  }

  function updateIds(ids = EMPTY.LIST) {
    return ids.push(uuid);
  }

  return result
    .update('byId', updateById)
    .update('ids', updateIds);
}

export function shapeImagesForApp(result, image) {
  const {
    alt_text: altText,
    connected_listing_count: listings,
    file_name: fileName,
    format,
    group_id: groupId,
    url,
    uuid,
  } = image;

  // TODO: check for API errors
  if (result.hasIn(['byId', uuid])) return result;

  function updateById(byId = EMPTY.MAP) {
    return byId.set(uuid,
      Map({
        altText,
        fileName,
        format,
        groupId,
        listings: parseInt(listings) || 0,
        mime: EXT_TO_MIME[format],
        url,
        uuid,
      })
    );
  }

  function updateIds(ids = EMPTY.LIST) {
    return ids.push(uuid);
  }

  return result
    .update('byId', updateById)
    .update('ids', updateIds);
}
